import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Icon } from "./icons.js";
/**
 * A product's picture by its barcode (any form: the till's padded code or the wholesaler's EAN). Loads lazily; when
 * there's no picture it shows a quiet placeholder with the product's initials, never a broken image.
 */
export function ProductImage({ code, name = "", size = 56, className = "" }) {
    const digits = String(code ?? "").replace(/\D/g, "").replace(/^0+/, "");
    const [failed, setFailed] = useState(false);
    const style = { width: size, height: size };
    if (!digits || failed) {
        const initials = name.replace(/[^A-Za-z ]/g, " ").trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase();
        return _jsx("span", { className: `tc-pimg tc-pimg-none ${className}`, style: style, "aria-hidden": "true", children: initials || _jsx(Icon, { name: "tag", size: Math.round(size * 0.4) }) });
    }
    return (_jsx("span", { className: `tc-pimg ${className}`, style: style, children: _jsx("img", { src: `/api/product-images/${digits}`, alt: "", loading: "lazy", decoding: "async", onError: () => setFailed(true) }) }));
}
